/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { Box, Heading, Text, Stack, Divider } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/dashboard/settings/navigation';
import AnnotatedSection from 'components/annotated-section';
import Card from 'components/card';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import { successNotice, errorNotice } from 'state/notices/actions';
import AnnotatedSectionSkeleton from 'components/skeleton-loader/annotated-section-skeleton';
import FormLabel from 'components/forms/form-label';
import cecSdk from 'lib/customer-ec-sdk';

/**
 * Style dependencies
 */
import './styles.scss';

const FtpMain = ({ ...props }) => {
    const [values, setValues] = useState({});
    const [requesting, setRequesting] = useState(true);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setRequesting(true);
            setError(null);

            let response = await cecSdk.userFtp().getFtpDetails();
            setValues(response);
        } catch (error) {
            setError(error.message);
        }

        setRequesting(false);
    };

    if (requesting || error) {
        return (
            <Main>
                <Stack space='large'>
                    <Navigation section='ftp' />
                    <AnnotatedSectionSkeleton />
                </Stack>
            </Main>
        );
    }

    // const handleOnChange = (e) => {
    //     let value = e.target.value;
    //     let name = e.target.name;

    //     setValues({ ...values, [name]: value });
    // };

    // const handleSubmit = async () => {
    //     setSubmitting(true);
    //     try {
    //         await cecSdk.userFtp().saveFtpDetails(values);
    //         props.successNotice('FTP details saved');
    //     } catch (error) {
    //         if (error.message && error.message == 'Invalid FTP details') {
    //             props.errorNotice('Invalid FTP details');
    //         } else {
    //             props.errorNotice('Error occoured. Failed to save.');
    //         }
    //     }
    //     setSubmitting(false);
    // };

    const handleFTPConnTest = async () => {
        setSubmitting(true);
        try {
            let { result } = await cecSdk.userFtp().testFtpConnection();
            if (parseInt(result) === 200) {
                props.successNotice('Valid FTP connection');
            } else {
                props.errorNotice('Invalid FTP connection');
            }
        } catch (error) {
           console.log(error.message);
        }
        setSubmitting(false);
    };

    return (
        <Main>
            <Stack space='large'>
                <Navigation section='ftp' />
                <Box paddingTop='xxlarge' paddingBottom='xxlarge'>
                    <Box display='flex' justifyContent='spaceBetween' alignItems='center' paddingBottom='xlarge'>
                        <Heading level='1'>FTP Settings</Heading>
                        <ButtonGroup>
                        <Button onClick={handleFTPConnTest}>Test FTP Connection</Button>
                        </ButtonGroup>
                    </Box>
                    <Divider />
                </Box>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='FTP Connection Details'
                            description={
                                <>
                                    <Text>Your Tower Advantage&trade; Link FTP connection details</Text>
                                    <Box marginTop='large'>
                                        <Text size='xsmall' weight='strong'>
                                            *Images are saved under ecommerce/images/%groupNumber%/*.jpg
                                        </Text>
                                    </Box>
                                </>
                            }
                        />
                        <AnnotatedSection.Content>
                            <Stack space='large'>
                                <Card>
                                    <Card.Section>
                                        <Stack space='large'>
                                            <Box>
                                                <FormLabel>Host:</FormLabel>
                                                <Text className="card__section-ftpinfo">{get(values, 'host')}</Text>
                                            </Box>
                                            <Box>
                                                <FormLabel>Username:</FormLabel>
                                                <Text className="card__section-ftpinfo">{get(values, 'username')}</Text>
                                            </Box>
                                            <Box>
                                                <FormLabel>Password:</FormLabel>
                                                <Text className="card__section-ftpinfo">{get(values, 'password')}</Text>
                                            </Box>
                                            <Box>
                                                <FormLabel>Port:</FormLabel>
                                                <Text className="card__section-ftpinfo">{get(values, 'port')}</Text>
                                            </Box>
                                        </Stack>
                                    </Card.Section>
                                </Card>
                            </Stack>
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Stack>
        </Main>
    );
};

export default connect(() => ({}), {
    successNotice,
    errorNotice,
})(FtpMain);
